(function () {
  function parseEnd(raw) {
    if (!raw) return null;
    // convert +0200 to +02:00 for Safari
    const fixed = raw.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");
    const d = new Date(fixed);
    return isNaN(d.getTime()) ? null : d;
  }

  function initCountdown(root) {
    const endRaw = root.getAttribute("data-end");
    const end = parseEnd(endRaw);
    if (!end) return;

    const dd = root.querySelector("[data-dd]");
    const hh = root.querySelector("[data-hh]");
    const mm = root.querySelector("[data-mm]");
    const ss = root.querySelector("[data-ss]");
    const bar = root.querySelector("[data-bar]");

    const start = Date.now();
    const totalMs = Math.max(1, end.getTime() - start);

    function render() {
      const now = Date.now();
      let diff = end.getTime() - now;

      if (diff <= 0) {
        dd.textContent = "0";
        hh.textContent = "0";
        mm.textContent = "0";
        ss.textContent = "0";
        if (bar) bar.style.width = "100%";
        return;
      }

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;

      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;

      const mins = Math.floor(diff / 60000);
      diff -= mins * 60000;

      const secs = Math.floor(diff / 1000);

      dd.textContent = String(days);
      hh.textContent = String(hours);
      mm.textContent = String(mins);
      ss.textContent = String(secs);

      // progress fill from 0 -> 100 until end
      if (bar) {
        const passed = Math.min(1, Math.max(0, (now - start) / totalMs));
        bar.style.width = (passed * 100).toFixed(2) + "%";
      }
    }

    render();
    // لو بيتكرر init في editor ما يعملش intervals كتير
    if (root._cdtInterval) clearInterval(root._cdtInterval);
    root._cdtInterval = setInterval(render, 1000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-countdown]").forEach(initCountdown);
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });

  // ✅ Shopify Theme Editor support
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();